import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const KINDS = [["received", "Joined the list (auto, from website)"], ["offer", "Offer a place"], ["decline", "Decline"], ["note", "Note / update"]];

export function WaitingListEmailsTab() {
  const [t, setT] = useState(null);
  const [placeholders, setPlaceholders] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/waiting-list/templates").then(r => { setT(r.data.templates); setPlaceholders(r.data.placeholders); }).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/waiting-list/templates", t); setT(r.data.templates); toast.success("Saved"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!t) return <div className="opacity-50 font-display tracking-widest">LOADING…</div>;
  return (
    <div className="space-y-5" data-testid="wl-emails-tab">
      <div>
        <h2 className="font-display font-black text-2xl">Waiting list emails</h2>
        <p className="opacity-60 text-sm mt-1">What parents receive at each step. Placeholders: {placeholders.map(p => <code key={p} className="text-[11px] px-1 py-0.5 rounded bg-white/10 mr-1">{p}</code>)}</p>
      </div>
      <label className="inline-flex items-center gap-3 card-tactical rounded-md px-4 py-3 cursor-pointer">
        <input type="checkbox" checked={!!t.enabled} onChange={e => setT({ ...t, enabled: e.target.checked })} className="accent-[#83B68B] w-4 h-4" data-testid="wl-emails-enabled" />
        <span className="text-sm">{t.enabled ? "Parent emails are ON" : "Parent emails are OFF — nothing is sent to parents"}</span>
      </label>
      <div className="grid md:grid-cols-2 gap-4">
        {KINDS.map(([k, label]) => (
          <div key={k} className="card-tactical rounded-md p-4 space-y-2" data-testid={`wl-tpl-${k}`}>
            <div className="text-[10px] tracking-widest uppercase text-[#83B68B]">{label}</div>
            <div><Label className="text-[10px] tracking-widest uppercase opacity-60">Subject</Label><Input value={t[`${k}_subject`] || ""} onChange={e => setT({ ...t, [`${k}_subject`]: e.target.value })} className="mt-1" data-testid={`wl-tpl-${k}-subject`} /></div>
            <div><Label className="text-[10px] tracking-widest uppercase opacity-60">Body</Label><Textarea rows={7} value={t[`${k}_body`] || ""} onChange={e => setT({ ...t, [`${k}_body`]: e.target.value })} className="mt-1 text-sm" data-testid={`wl-tpl-${k}-body`} /></div>
          </div>
        ))}
      </div>
      <button type="button" onClick={save} disabled={busy} className="btn-volt px-5 py-2.5 rounded-md text-sm disabled:opacity-40" data-testid="wl-emails-save">{busy ? "Saving…" : "Save templates"}</button>
    </div>
  );
}
